<div mat-dialog-title>
  <span>{{ 'CORE.RESOURCES.CREATE_RESOURCE' | translate }}</span>
  <q9-dialog-close-button></q9-dialog-close-button>
</div>

<q9-info-message *ngIf="error" type="error">
  {{ error | translate }}
</q9-info-message>

<mat-dialog-content class="content">
  <form [formGroup]="addResourceForm" #form="ngForm" class="form-content">
    <q9-text-field formControlName="name" [label]="'CORE.RESOURCES.LABEL_NAME'"></q9-text-field>

    <q9-select formControlName="type" [label]="'CORE.RESOURCES.LABEL_TYPE'">
      <q9-option *ngFor="let type of types | keyvalue: typeOrderFn" [value]="type.key">
        {{ type.value }}
      </q9-option>
    </q9-select>

    <q9-textarea-field
      formControlName="description"
      [label]="'CORE.RESOURCES.LABEL_DESCRIPTION'"
      [minRows]="3"
      [maxRows]="10"></q9-textarea-field>

    <div class="toggles">
      <mat-slide-toggle
        *ngIf="data.isPro && !isArchitectural"
        [checked]="!attachHidden"
        (change)="changeHiddenFlag.emit(!$event.checked)">
        {{ 'CORE.RESOURCES.VISIBLE_RESOURCE' | translate }}
      </mat-slide-toggle>

      <mat-slide-toggle *ngIf="isArchitectural" (change)="creatingMain($event.checked)">
        {{ 'CORE.RESOURCES.MAIN_ON_CARD_LABEL' | translate }}
      </mat-slide-toggle>

      <mat-slide-toggle (change)="toggleIconEdit($event.checked)">
        {{ 'ASIDE_R.RESOURCE_SET_ICON' | translate }}
      </mat-slide-toggle>
    </div>
  </form>

  <div *ngIf="editIcon" class="icon-editor">
    <div>
      <input
        type="file"
        accept="image/*"
        #file
        (change)="fileChangeEvent($event)"
        style="display: none" />
      <q9-link-button (click)="file.click()">
        {{ 'ASIDE_R.ADD_RESOURCE_ICON' | translate }}
      </q9-link-button>
    </div>
    <image-cropper
      *ngIf="fileEvent"
      class="image-cropper"
      [imageChangedEvent]="fileEvent"
      [maintainAspectRatio]="true"
      [aspectRatio]="1"
      [resizeToWidth]="130"
      outputType="file"
      format="png"
      (imageCropped)="imageCropped($event)"></image-cropper>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <q9-link-button *ngIf="canSwitchToList" (click)="switchCreateMode.emit()">
    {{ 'CORE.RESOURCES.SWITCH_BACK' | translate }}
  </q9-link-button>

  <q9-secondary-button mat-dialog-close>
    {{ 'CORE.RESOURCES.CANCEL' | translate }}
  </q9-secondary-button>

  <q9-primary-button
    [isLoading]="isLoading()"
    (click)="form.onSubmit($event); !isLoading() && createAndAddResource()">
    {{ 'CORE.RESOURCES.CREATE' | translate }}
  </q9-primary-button>
</mat-dialog-actions>
